import { Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import ModalShell from '@/components/modal-shell';
import { Button } from '@/components/ui/button';

interface DeleteConfirmModalProps {
  taskTitle: string;
  onConfirm: () => void;
  onClose: () => void;
}

export default function DeleteConfirmModal({ taskTitle, onConfirm, onClose }: DeleteConfirmModalProps) {
  const { t } = useTranslation();
  return (
    <ModalShell title={t('modals.deleteTask.title')} onClose={onClose} maxWidth='max-w-sm' bottomSheetOnPhone
      /* `text-ws-text`, like the other two delete confirms. It was `text-red-500` — a raw colour
         that ignores the theme and does not follow dark mode, which is the objection this file
         already raised about its own button and had not yet applied to its icon. */
      icon={<Trash2 aria-hidden='true' className='h-4 w-4 shrink-0 text-ws-text' />}>
      <div className='flex flex-col gap-6'>
        <p className='text-sm text-ws-muted'>{t('modals.deleteTask.message', { title: taskTitle })}</p>
        <div className='flex gap-3'>
          <Button variant='secondary' onClick={onClose} className='flex-1'>
            {t('common.cancel')}
          </Button>
          {/* Primary, like every other destructive confirm in the app — this one had been the
              outlier, on a raw `bg-red-500` that ignores the theme and does not follow dark mode.
              The danger is carried by the wording and by the modal, not by a colour used nowhere
              else; a filled red button exists in no other place here. */}
          <Button variant='primary' onClick={onConfirm} className='flex-1'>
            {t('common.delete')}
          </Button>
        </div>
      </div>
    </ModalShell>
  );
}
